import { LucideIcon } from "lucide-react";

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  delay?: string;
}

export const FeatureCard = ({ icon: Icon, title, description, delay = "0.2s" }: FeatureCardProps) => {
  return (
    <div 
      className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 animate-scale-in" 
      style={{ animationDelay: delay }}
    >
      <div className="p-3 bg-[#F1F0FB] rounded-full w-fit mb-4">
        <Icon className="h-6 w-6 text-primary" />
      </div>
      <h3 className="text-xl font-semibold text-primary-dark mb-2">{title}</h3>
      <p className="text-neutral">{description}</p>
    </div>
  );
};